import ResourceService from './resource.service'

class TGATypeService extends ResourceService {
  static get resource() {
    return 'tga'
  }
}

export default TGATypeService
